import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewChild,
    OnChanges,
} from '@angular/core';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Document } from 'src/app/acl-data/document/document.dto';

@Component({
    selector: 'app-document-view-preview',
    templateUrl: './document-view-preview.component.html',
    styleUrls: ['./document-view-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentViewPreviewComponent implements OnChanges {
    @Input() document: Document;

    @Input() objectStore: string;
    @Input() showAll = false;

    @ViewChild('thumbnailImg', { static: false }) thumbnailImg;

    viewMode = false;

    filenetURL = environment.serviceURL_ACL;
    views;

    thumbnailWait = false;

    thumbnailError() {
        console.log('Thumbnail not yet available');
        this.thumbnailWait = true;
        of('Request Complete!')
            .pipe(delay(30000))
            .subscribe(() => {
                console.log('Get here');
                this.thumbnailWait = false;
            });
    }

    constructor() {}

    ngOnChanges() {
        // console.log('Calc', this.document);
        if (this.document && this.document.audits) {
            this.views = this.document.audits.filter(
                value =>
                    value.propertiesObj.ClassDescription === 'GetContentEvent'
            ).length;
        } else {
            this.views = 0;
        }
    }

    increaseDL = () => {
        this.views = this.views + 1;
    };

    goToViewMode = () => {
        this.increaseDL();
        this.viewMode = true;
    };
}
